import { BehaviorSubject } from 'rxjs'
import { Platform } from '@ionic/angular'
import { Injectable } from '@angular/core'
import { FCM } from '@ionic-native/fcm/ngx'

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {

  private onNotificationSubscription: any
  pushNotifications: BehaviorSubject<string> = new BehaviorSubject<string>(null)

  constructor(
    private fcm: FCM,
    private platform: Platform
  ) { }

  initialize() {
    return this.platform.ready()
      .then(() => {

        // this.getDeviceToken().then(console.log)

        this.onNotificationSubscription = this.fcm.onNotification().subscribe(data => {
          console.log('Notification recieved: ', data)
          if (data)
            this.pushNotifications.next(data.body as string)
        })
      })
  }

  destroy() {
    if (this.onNotificationSubscription)
      this.onNotificationSubscription.unsubscribe()
  }

  getDeviceToken() {
    if (this.platform.is('ios'))
      return this.fcm.getAPNSToken() // .then(token => // console.log('APNSToken: ', token))
    else if (this.platform.is('android'))
      return this.fcm.getToken() // .then(token => // console.log('FCMToken: ', token))
    else
      return Promise.reject('Error registering device for Push Notifications: not a mobile device!')
  }
}
